import {
    Box,
    Heading,
    Text,
    Link,
    Flex,
    Spinner
} from '@theme-ui/components'
import { Container } from '~/Common'
import { useTranslation } from 'react-i18next'
import { AnnouncementRowCompact } from '~/Common/AnnouncementRow';
import { toast } from 'react-toastify';
import { grabFirstError } from 'utils/helpers';
import { fetchUserOpentrader } from 'features/auth/authAPI';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export const AsxAnnouncementsCompact = ({ data, user, emptyAction, isLoading }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const announcements = data?.announcements ?? null;
    const noAnnouncements = announcements?.length === 0;

    const handleOpentraderOnClick = (e) => {
        e.preventDefault();

        if(!user?.user?.can_see_trade_link){
            if(!user?.user?.finished_onboarding_details){
                toast.info(t('login.opentrader_not_ready_finish_onboarding'), {
                    toastId: 'opentrader-warning'
                })
                history.push('/onboarding');
            }
            toast.info(t('login.opentrader_not_ready'), {
                toastId: 'opentrader-warning'
            })
            return;
        }

        fetchUserOpentrader().then((response) => {
            if (response?.redirect_uri && response?.token){
                setTimeout(() => {
                    window.open(`${response.redirect_uri}?token=${response.token}`, '_blank');
                });
            }else{
                toast.error(t('login.opentrader_error'), {
                    toastId: 'opentrader-error'
                })
            }
        }).catch(({ response }) => {
            toast.error((grabFirstError(response.data?.errors) || response.data?.message) ?? t('login.opentrader_error'), {
                toastId: 'opentrader-error'
            })
        });
    };

    const subtitle = user?.user?.can_see_trade_link ? 
        t('Full ASX Announcements can be viewed in your live trade screen by clicking the <trade> link above.', {trade: <Link as="a" onClick={handleOpentraderOnClick}>'Trade'</Link>}) : 
        <>{t('Liquidity members can view live ASX Announcements in their Trade screen. Contact us at <email> to find out more.', {email: <Link href="mailto:members@liquidity.com.au" sx={{ color: 'dark' }}>members@liquidity.com.au</Link>})}</>;

    return (
        <Box my={2} id="latest-news">
            <Container>
                <Heading as="h3" variant="content_block_heading" mb={0}>{t('Latest ASX Announcements')}
                    <Text as="p" variant="small" mt={3} sx={{ fontStyle: 'italic' }}>
                        {subtitle}
                    </Text>
                </Heading>
                {isLoading ? (
                        <Flex sx={{
                            flexDirection: 'column',
                            bg: 'rgba(255, 255, 255, 0.5)'
                        }}>
                            <Spinner variant="styles.spinner" mx={'auto'} mt={4} />
                        </Flex>
                    ) : (
                        <Box sx={{ display: noAnnouncements ? 'flex' : 'block', justifyContent: noAnnouncements ? 'center' : 'left' }}>
                            {noAnnouncements && emptyAction ? (
                                emptyAction
                            ): announcements?.map((announcement, index) => (
                                <AnnouncementRowCompact key={index} announcement={announcement} canSeeTradeLink={user?.user?.can_see_trade_link} />
                            ))}
                        </Box>
                    )}

            </Container>
        </Box>
    )
};
